import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { INSTAGRAM_PATH, EMAIL_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";
import { Tab } from "@own-local/ad-unit/lib/AdUnit";

const ADDITIONAL_TEXT_SPELL_NAME = "additional_text";

const FillOrigamiStepProps = {
  previous: INSTAGRAM_PATH,
  next: EMAIL_PATH,
  question: "Additional Offer Text",
  description: "Write more about your offer or story.",
  spellName: ADDITIONAL_TEXT_SPELL_NAME,
  placeholder: "",
  textArea: true,
  required: false,
  selectedTab: Tab.About,
};

export const AdditionalTextStep: FunctionComponent<WizardProps> = (
  props: WizardProps,
) => <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />;

export default WizardContainer(AdditionalTextStep);
